import { useState, useEffect } from 'react';

/**
 * Custom hook to load static ratings data for schema.org
 * This ensures ratings are available immediately for SSR and Google indexing
 */
const useStaticRatings = (toolId) => {
    const [staticRatings, setStaticRatings] = useState({
        average: 0,
        count: 0,
        isLoaded: false,
        hasValidRatings: false
    });

    useEffect(() => {
        const loadStaticRatings = async () => {
            try {
                const response = await fetch('/ratings.json');
                if (response.ok) {
                    const data = await response.json();
                    const toolData = data.tools[toolId];
                    
                    if (toolData) {
                        const average = toolData.average || 0;
                        const count = toolData.count || 0;
                        const hasValidRatings = count > 0 && average > 0;
                        
                        setStaticRatings({
                            average: hasValidRatings ? average : 0,
                            count: hasValidRatings ? count : 0,
                            isLoaded: true,
                            hasValidRatings,
                            lastUpdated: toolData.lastUpdated
                        });
                        
                        console.log(`Static ratings loaded for ${toolId}:`, {
                            average: hasValidRatings ? average : 0,
                            count: hasValidRatings ? count : 0,
                            hasValidRatings
                        });
                    } else {
                        // Tool not found in static data
                        setStaticRatings({
                            average: 0,
                            count: 0,
                            isLoaded: true,
                            hasValidRatings: false
                        });
                    }
                } else {
                    // Static file not available
                    console.log('Static ratings file not available, using defaults');
                    setStaticRatings({
                        average: 0,
                        count: 0,
                        isLoaded: true,
                        hasValidRatings: false
                    });
                }
            } catch (error) {
                console.error('Error loading static ratings:', error);
                setStaticRatings({
                    average: 0,
                    count: 0,
                    isLoaded: true,
                    hasValidRatings: false
                });
            }
        };

        loadStaticRatings();
    }, [toolId]);

    return staticRatings;
};

export default useStaticRatings; 